import { PlaceMedia } from './get'


export const URL = '/v2/pms/accomodations/:placeId/media/:imgId/'

export type Req = {
  description: string
}

export type Resp = PlaceMedia